import { useCurrentPostHelpers } from "@circle-react/components/PostsV3/useCurrentPostHelpers";
import { hasEmoji } from "@circle-react/helpers/spaceHelpers";

export const SpaceName = ({ space }) => {
  const { isSharedPostViewWithMinimalLayout } = useCurrentPostHelpers();
  if (!space || !isSharedPostViewWithMinimalLayout) {
    return null;
  }

  return (
    <div className="post__space">
      {hasEmoji(space) && <span>{space.emoji}</span>}
      <span>{space.name}</span>
    </div>
  );
};
